function setupResourcePage() {  
  if (jQuery('section > div').hasClass('resources')) {
    setupResourceInfiniteScroll();  
    setupResourceCheckMarks();
    setupResourceSearchBox();
    floatResourceSideBarOnScroll();
  }
}

var resourcePage = 1;
var resourceLastPage = false;
var resourceInfiniteInprogress = false;
var resourceLoadMoreTimeout = null;
var resourceFilterTag = '';
var resourceFilterSearch = '';

function floatResourceSideBarOnScroll() {
  var explicitlySetAffixPosition = function() {
  };
  
  //Safari Bug.
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    var explicitlySetAffixPosition = function() {
      $('.resources #sidebar').css('left', ($('.resources #sidebar').parent().offset().left + 10) + 'px');
    };
  }
  
  $('.resources #sidebar').affix({
    offset: {
      top: 200,
      bottom: function () {
        //console.log(jQuery('footer').outerHeight(true));
        return (this.bottom = jQuery('footer').outerHeight(true)-20)
      }
    }
  }).on('affixed.bs.affix', function() {
      explicitlySetAffixPosition();
  }).on('affixed-bottom.bs.affix', function() {
     jQuery(this).css('position', 'fixed');
  }).on('affixed-top.bs.affix', function() {
     jQuery(this).css('position', '');
  });
}

function setupResourceSearchBox() {
  jQuery('.resources #search').click(function(e) {
    e.preventDefault();
    resourceFilterSearch = jQuery('.resources #search-text').val();
    resourceFilter();
  });
}

function setupResourceCheckMarks() {
  jQuery('.resources .check-mark').unbind().click(function(e) {
    e.preventDefault();
    
    if (jQuery(this).hasClass('checked'))
      jQuery(this).removeClass('checked');      
    else
      jQuery(this).addClass('checked');
    
    resourceFilter();
  });
}

function setupResourceInfiniteScroll() {
  jQuery(window).scroll(function() {
    if (jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() - 100) {
      loadMoreResources();
    }
  });
}

function loadMoreResources() {
  if (resourceInfiniteInprogress)
    return;
  
  if (resourceLastPage)
    return;
  
  resourceLoadMoreTimeout = setTimeout(function(){ 
    resourceInfiniteInprogress = true;
    resourcePage++;
    var parameters = '&tag=' + resourceFilterTag + '&search=' + resourceFilterSearch;
    jQuery.get('/learning-center/list?limit=9&page=' + resourcePage + parameters, function(data) {
      if (data.length > 0 ) {
        jQuery.each(data, function(index, resource) {   
          appendResourceToGallery(resource);
        });
        
        setupColorBoxYoutubeVideos();
        resourceInfiniteInprogress = false;
      } else {
        resourceLastPage = true;
        resourceInfiniteInprogress = false;
      }
    });
  }, 200);
}

function appendResourceToGallery(resource)
{
  var template = jQuery('#templates #resource').clone();            

  jQuery(template).find('h3').html(resource.name);
  
  jQuery(template).find('a').attr('embeded-code', resource.code);
  jQuery(template).find('a img').attr('src', 'http://img.youtube.com/vi/' + resource.code + '/mqdefault.jpg'); 
  
  jQuery('.resources .grid').append(template);
}

function getResourceFilterValues()
{
  resourceFilterTag = '';
  jQuery('.resources .filter .tags > li a.checked').each(function (index) {
    var id = jQuery(this).attr('id');
    if (id > 0)
      resourceFilterTag += id + ',';
  }); 
  resourceFilterTag = resourceFilterTag.substring(0, resourceFilterTag.length - 1)  
}

function resourceFilter()
{
  getResourceFilterValues();
  
  resourcePage = 1;
  resourceLastPage = false;
  var parameters = '&tag=' + resourceFilterTag + '&search=' + resourceFilterSearch;
  
  jQuery.get('/learning-center/list?' + parameters, function(data) {
    jQuery('.resources .grid').html('');
    if (data.length > 0 ) {      
      jQuery.each(data, function(index, resource) {   
        appendResourceToGallery(resource);
      });
      
      setupColorBoxYoutubeVideos();
    }
  });
}